import { buildSlice, CommonState } from '~libs/reduxUtils';

import { FundingType } from '~support-at-home/models';

import { getAll, getAllSah, getOne, typePrefix } from '~support-at-home/actions/fundingTypes';

interface State extends CommonState<FundingType> {
  clientFundingTypes: FundingType[];
  sahFundingTypes: FundingType[];
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  clientFundingTypes: [],
  sahFundingTypes: [],
};

const slice = buildSlice<State, FundingType>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
  extraReducers: (builder) => {
    builder.addCase(getAllSah.fulfilled, (state, action) => {
      state.sahFundingTypes = action.payload.data;
    });
  },
});

export const { clear, clearError } = slice.actions;
export default slice.reducer;
